import {button,escapeHtml,message,panel} from '../ui/components.js';
import {emptyState,errorState,loadingState} from '../ui/states.js';
import {recipeLibraryCard} from './library.js';

function formatMinutes(value){
  const minutes=Number(value);
  if(!Number.isFinite(minutes)||minutes<=0)return 'czas do ustalenia';
  const hours=Math.floor(minutes/60),rest=Math.round(minutes%60);
  if(!hours)return rest+' min';
  return rest?hours+' h '+rest+' min':hours+' h';
}

function sourceLabel(type){
  if(type==='official')return 'Oficjalna';
  if(type==='community')return 'Społeczność';
  return 'Prywatna';
}

function compatibilityLabel(value){
  if(value==='compatible')return 'zgodna ze sprzętem';
  if(value==='incompatible')return 'poza zakresem sprzętu';
  if(value==='review')return 'sprawdź sprzęt';
  return 'zgodność nieznana';
}

function option(value,label,current=''){
  return '<option value="'+escapeHtml(value)+'"'+(value===current?' selected':'')+'>'+escapeHtml(label)+'</option>';
}

function libraryCardMarkup(entry){
  const card=recipeLibraryCard(entry);
  const products=card.products.slice(0,3).join(' · ')||'Produkt do ustalenia';
  const metadata=[
    formatMinutes(card.approximateMinutes),
    card.primaryWood||'drewno do ustalenia',
    card.difficulty==='unknown'?'poziom do ustalenia':card.difficulty,
    compatibilityLabel(card.compatibility)
  ].map(value=>'<span>'+escapeHtml(value)+'</span>').join('');
  return '<article class="recipe-card">'
    +'<div class="recipe-card-head"><span class="recipe-type recipe-type-'+escapeHtml(card.type)+'">'+escapeHtml(sourceLabel(card.type))+'</span>'
    +'<h3>'+escapeHtml(card.title)+'</h3></div>'
    +'<p class="recipe-products">'+escapeHtml(products)+'</p>'
    +'<div class="recipe-card-meta">'+metadata+'</div>'
    +(card.experienceGuidance?'<p class="recipe-guidance">'+escapeHtml(card.experienceGuidance)+'</p>':'')
    +button({label:'Otwórz recepturę',variant:'secondary',className:'recipe-open',attributes:{'data-recipe-open':card.id}})
    +'</article>';
}

function libraryMarkup(state){
  const filters=state.filters||{};
  const scope=state.scope||'public';
  const scopeButtons='<div class="recipe-scope" role="group" aria-label="Zakres receptur">'
    +button({label:'Odkrywaj',variant:scope==='public'?'primary':'ghost',attributes:{'data-recipe-scope':'public'}})
    +button({label:'Zapisane',variant:scope==='saved'?'primary':'ghost',attributes:{'data-recipe-scope':'saved'}})
    +button({label:'Moje',variant:scope==='mine'?'primary':'ghost',attributes:{'data-recipe-scope':'mine'}})
    +'</div>';

  const form='<form id="recipe-filter-form" class="recipe-filters">'
    +'<label class="field"><span class="field-label">Szukaj</span><input name="query" type="search" value="'+escapeHtml(filters.query||'')+'" placeholder="Nazwa lub produkt"></label>'
    +'<label class="field"><span class="field-label">Kategoria</span><select name="productCategory">'
      +option('','Wszystkie',filters.productCategory||'')
      +option('pork','Wieprzowina',filters.productCategory||'')
      +option('beef','Wołowina',filters.productCategory||'')
      +option('poultry','Drób',filters.productCategory||'')
      +option('fish','Ryby',filters.productCategory||'')
      +option('sausage','Kiełbasy',filters.productCategory||'')
      +option('cheese','Sery',filters.productCategory||'')
      +option('vegetables','Warzywa',filters.productCategory||'')
      +option('other','Inne',filters.productCategory||'')
    +'</select></label>'
    +'<label class="field"><span class="field-label">Proces</span><select name="stageType">'
      +option('','Wszystkie',filters.stageType||'')
      +option('drying','Osuszanie',filters.stageType||'')
      +option('smoking','Wędzenie',filters.stageType||'')
      +option('baking','Podpiekanie',filters.stageType||'')
      +option('steaming','Parzenie / para',filters.stageType||'')
    +'</select></label>'
    +'<label class="field"><span class="field-label">Sprzęt</span><select name="compatibility">'
      +option('','Dowolna zgodność',filters.compatibility||'')
      +option('compatible','Zgodne',filters.compatibility||'')
      +option('review','Do sprawdzenia',filters.compatibility||'')
      +option('unknown','Nieznane',filters.compatibility||'')
    +'</select></label>'
    +button({label:'Filtruj',type:'submit',variant:'primary'})
    +'</form>';

  if(!state.entries.length){
    return '<div class="recipe-library">'+scopeButtons+form
      +emptyState({
        title:scope==='mine'
          ?'Nie masz jeszcze własnych receptur'
          :scope==='saved'
            ?'Nie masz zapisanych receptur'
            :'Brak receptur spełniających kryteria',
        text:scope==='mine'
          ?'Prywatne receptury pojawią się tutaj po utworzeniu ich z własnego procesu.'
          :scope==='saved'
            ?'Zapisz recepturę z widoku szczegółów, aby wrócić do niej później na wszystkich urządzeniach.'
            :'Zmień wyszukiwanie lub filtry. Prywatne receptury nie są pokazywane w publicznym odkrywaniu.'
      })+'</div>';
  }

  return '<div class="recipe-library">'+scopeButtons+form
    +'<div class="recipe-results-head"><strong>'+state.entries.length+' receptur</strong><span>Widok nastawiony na wykonanie procesu, nie feed treści.</span></div>'
    +'<div class="recipe-grid">'+state.entries.map(libraryCardMarkup).join('')+'</div></div>';
}

function itemMarkup(item){
  const amount=[
    item.quantity!=null?item.quantity+' szt.':null,
    item.mass!=null?item.mass+' '+(item.massUnit||''):null
  ].filter(Boolean).join(' · ');
  const prep=item.preparation;
  const notes=prep
    ?[prep.curingNotes,prep.marinadeNotes,prep.spicesNotes,prep.dryingNotes,prep.preparationNotes].filter(Boolean).join(' · ')
    :'';
  return '<li><div><strong>'+escapeHtml(item.name)+'</strong>'
    +(amount?'<span>'+escapeHtml(amount)+'</span>':'')
    +(notes?'<small>'+escapeHtml(notes)+'</small>':'')
    +'</div></li>';
}

function stageMarkup(stage){
  const target=stage.target;
  const targetBits=[];
  if(target?.targetChamberCelsius!=null)targetBits.push('komora '+target.targetChamberCelsius+'°C');
  if(target?.minChamberCelsius!=null||target?.maxChamberCelsius!=null){
    targetBits.push('zakres '+(target.minChamberCelsius??'—')+'–'+(target.maxChamberCelsius??'—')+'°C');
  }
  if(target?.plannedDurationMinutes!=null)targetBits.push(formatMinutes(target.plannedDurationMinutes));
  const internal=stage.itemTargets.map(item=>item.itemName+' '+item.targetInternalCelsius+'°C').join(' · ');
  return '<li class="recipe-stage"><span class="recipe-stage-number">'+stage.number+'</span><div>'
    +'<strong>'+escapeHtml(stage.name)+'</strong>'
    +(targetBits.length?'<span>'+escapeHtml(targetBits.join(' · '))+'</span>':'')
    +(internal?'<span>'+escapeHtml(internal)+'</span>':'')
    +(stage.instructions?'<p>'+escapeHtml(stage.instructions)+'</p>':'')
    +'</div></li>';
}

function controlledSafetyMarkup(rules=[]){
  if(!rules.length)return '';
  return '<section class="recipe-safety" aria-label="Kontrolowane informacje bezpieczeństwa">'
    +'<strong>Kontrolowane informacje bezpieczeństwa</strong>'
    +'<ul>'+rules.map(rule=>{
      const reference=rule.reference;
      const refLabel='Źródło: '+reference.knowledgeId+' · v'+reference.version;
      const ref=reference.url
        ?'<a href="'+escapeHtml(reference.url)+'" target="_blank" rel="noopener noreferrer">'+escapeHtml(refLabel)+'</a>'
        :'<span>'+escapeHtml(refLabel)+'</span>';
      return '<li><strong>'+escapeHtml(rule.title)+'</strong><p>'+escapeHtml(rule.text)+'</p>'+ref+'</li>';
    }).join('')+'</ul></section>';
}

function userSafetyMarkup(notes=[],type='community'){
  if(!notes.length)return '';
  const heading=type==='community'
    ?'Uwagi autora społeczności — niezweryfikowane'
    :'Uwagi użytkownika — niezweryfikowane';
  return '<section class="recipe-user-safety" aria-label="'+escapeHtml(heading)+'">'
    +'<strong>'+escapeHtml(heading)+'</strong>'
    +'<p>Te informacje nie są oznaczone jako kontrolowane zasady bezpieczeństwa żywności.</p>'
    +'<ul>'+notes.map(note=>'<li>'+escapeHtml(note)+'</li>').join('')+'</ul></section>';
}

function detailMarkup(state){
  const detail=state.detail;
  const trust=detail.source.trust;
  const sourceName=detail.source.sourceName||detail.source.authorName||'Źródło nieopisane';
  const sourceLink=detail.source.sourceUrl
    ?'<a href="'+escapeHtml(detail.source.sourceUrl)+'" target="_blank" rel="noopener noreferrer">'+escapeHtml(sourceName)+'</a>'
    :escapeHtml(sourceName);
  const source=sourceLink+' · v'+escapeHtml(detail.source.version);
  const wood=detail.woods.map(item=>item.name+(item.sharePercent!=null?' '+item.sharePercent+'%':'')).join(' · ');
  const safety=controlledSafetyMarkup(detail.safetyRules);
  const userSafety=userSafetyMarkup(detail.userSafetyNotes,detail.source.type);
  const tips=detail.tips.length
    ?'<section class="recipe-tips"><strong>Wskazówki opcjonalne</strong><ul>'+detail.tips.map(tip=>'<li>'+escapeHtml(tip)+'</li>').join('')+'</ul></section>'
    :'';
  const actions='<div class="recipe-detail-actions">'
    +button({label:'Użyj tej receptury',variant:'primary',attributes:{'data-recipe-use':detail.id}})
    +button({label:state.saved?'Usuń z zapisanych':'Zapisz',variant:'secondary',disabled:!state.capabilities?.save,attributes:{'data-recipe-secondary':'save'}})
    +(detail.actions.copy?button({label:'Kopiuj do prywatnych',variant:'ghost',disabled:!state.capabilities?.copy,attributes:{'data-recipe-secondary':'copy'}}):'')
    +'</div>';

  return '<article class="recipe-detail">'
    +button({label:'Wróć do receptur',variant:'ghost',attributes:{'data-recipe-back':'1'}})
    +'<header class="recipe-detail-head">'
    +'<span class="recipe-type recipe-type-'+escapeHtml(detail.source.type)+'">'+escapeHtml(trust.label)+'</span>'
    +'<h2>'+escapeHtml(detail.title)+'</h2>'
    +(detail.description?'<p>'+escapeHtml(detail.description)+'</p>':'')
    +'<p class="recipe-trust-explanation">'+escapeHtml(trust.explanation)+'</p>'
    +'<div class="recipe-detail-meta"><span>'+source+'</span><span>'+escapeHtml(formatMinutes(detail.approximateMinutes))+'</span><span>'+escapeHtml(compatibilityLabel(detail.compatibility))+'</span></div></header>'
    +message({text:state.notice||'',kind:state.noticeKind||'neutral'})
    +(state.savedSourceState?.updateAvailable
      ?message({text:'Źródłowa receptura ma nowszą wersję. Twoje wcześniej utworzone sesje zachowują zapisaną wersję.',kind:'warning'})
      :'')
    +safety+userSafety
    +panel({title:'Produkty i przygotowanie',body:'<ul class="recipe-detail-list">'+detail.items.map(itemMarkup).join('')+'</ul>'})
    +panel({title:'Drewno',body:wood?'<p class="recipe-detail-copy">'+escapeHtml(wood)+'</p>':'<p class="recipe-detail-copy">Brak wskazanego drewna.</p>'})
    +panel({title:'Proces krok po kroku',body:'<ol class="recipe-stage-list">'+detail.stages.map(stageMarkup).join('')+'</ol>'})
    +tips+actions+'</article>';
}

export function renderRecipePage(state){
  if(!state||state.kind==='loading')return loadingState({title:'Ładowanie receptur',text:'Czytamy lokalny katalog i przygotowujemy widok.'});
  if(state.kind==='error')return errorState({title:'Nie udało się otworzyć receptur',text:'Lokalne dane pozostają bezpieczne.',retryId:'recipes-retry'});
  if(state.kind==='detail')return detailMarkup(state);
  return libraryMarkup(state);
}
